import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Mail, MessageCircle, Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { NotificationHub } from '@/components/settings/NotificationHub';

/**
 * Notification preferences tab — extracted from SettingsPage.jsx (iter790).
 * BranchWaButtons & ComplianceAlertsCard live in the parent and are passed in.
 */
export function SettingsNotificationsTab({ notifPrefs, setNotifPrefs, savePrefs, sendDailyReport, BranchWaButtons, ComplianceAlertsCard }) {
  return (
    <>
      <Card className="border-border">
        <CardHeader><CardTitle className="font-outfit">Notification Preferences</CardTitle></CardHeader>
        <CardContent className="space-y-6">
          <p className="text-sm text-muted-foreground">Choose what notifications to send via email and WhatsApp</p>

          <div className="space-y-4">
            <h3 className="font-medium text-sm flex items-center gap-2"><Mail size={16} />Email Notifications</h3>
            <div className="space-y-3 pl-6">
              <div className="flex items-center gap-3"><Checkbox checked={notifPrefs.email_daily_sales} onCheckedChange={(v) => setNotifPrefs({ ...notifPrefs, email_daily_sales: v })} /><Label>Daily Sales Summary</Label></div>
              <div className="flex items-center gap-3"><Checkbox checked={notifPrefs.email_document_expiry} onCheckedChange={(v) => setNotifPrefs({ ...notifPrefs, email_document_expiry: v })} /><Label>Document Expiry Alerts</Label></div>
              <div className="flex items-center gap-3"><Checkbox checked={notifPrefs.email_leave_updates} onCheckedChange={(v) => setNotifPrefs({ ...notifPrefs, email_leave_updates: v })} /><Label>Leave Request Updates</Label></div>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="font-medium text-sm flex items-center gap-2"><MessageCircle size={16} />WhatsApp Notifications</h3>
            <div className="space-y-3 pl-6">
              <div className="flex items-center gap-3"><Checkbox checked={notifPrefs.whatsapp_daily_sales} onCheckedChange={(v) => setNotifPrefs({ ...notifPrefs, whatsapp_daily_sales: v })} /><Label>Daily Sales Summary</Label></div>
              <div className="flex items-center gap-3"><Checkbox checked={notifPrefs.whatsapp_document_expiry} onCheckedChange={(v) => setNotifPrefs({ ...notifPrefs, whatsapp_document_expiry: v })} /><Label>Document Expiry Alerts</Label></div>
            </div>
          </div>

          <div className="flex gap-3 pt-2">
            <Button onClick={savePrefs} className="rounded-full" data-testid="save-prefs">Save Preferences</Button>
            <div className="flex gap-2 flex-wrap">
              <Button variant="outline" onClick={sendDailyReport} className="rounded-xl" data-testid="send-report"><Send size={14} className="mr-2" />Daily Sales</Button>
              <Button variant="outline" className="rounded-xl" onClick={async () => { try { const res = await api.post('/whatsapp/send-supplier-report'); toast.success(res.data.message); } catch(e) { toast.error(e.response?.data?.detail || 'Failed'); } }}><Send size={14} className="mr-2" />Supplier Report</Button>
              <Button variant="outline" className="rounded-xl" onClick={async () => { try { const res = await api.post('/whatsapp/send-employee-report', {}); toast.success(res.data.message); } catch(e) { toast.error(e.response?.data?.detail || 'Failed'); } }}><Send size={14} className="mr-2" />Employee Report</Button>
            </div>

            <div className="mt-3">
              <Label className="text-xs mb-2 block">Send Branch Report via WhatsApp</Label>
              {BranchWaButtons && <BranchWaButtons />}
            </div>
            <div className="mt-3 p-3 bg-muted/50 rounded-xl border">
              <Label className="text-xs">Send Custom Message via WhatsApp</Label>
              <div className="flex gap-2 mt-2">
                <Input id="custom-wa-msg" placeholder="Type your message..." className="h-9" />
                <Button variant="outline" className="rounded-xl h-9" onClick={async () => {
                  const msg = document.getElementById('custom-wa-msg').value;
                  if (!msg) { toast.error('Enter a message'); return; }
                  try { const res = await api.post('/whatsapp/send-custom', { message: msg }); toast.success(res.data.message); document.getElementById('custom-wa-msg').value = ''; } catch(e) { toast.error(e.response?.data?.detail || 'Failed'); }
                }}><Send size={14} className="mr-1" />Send</Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      {ComplianceAlertsCard && <ComplianceAlertsCard />}
      <NotificationHub />
    </>
  );
}

export default SettingsNotificationsTab;
